module.exports = __webpack_public_path__ + "img/0859-cross-circle.2f97a265.svg";